import React from "react";
import {getPackageUID, PACKAGE_STATES} from "../../../../lib/WarehouseHelper";
import {updatePackages} from "../../../../actions/WarehousePackageActions";
import {graphql} from "react-apollo";
import {compose} from "redux";
import {CANCEL_BATCH_PICKING, MARK_BATCH_PICKED} from "../../../../queries/warehouseJobs";
import Button from "../../../../components/Button";
import {useDispatch} from "react-redux";
import {Set} from "immutable";
import {connect} from "react-redux";
import {showContextualMenu} from "../../../../actions/ViewActions";
import ContextMenuTrigger from "../../../../components/ContextMenuTrigger";
import ArrowBack from "../../../../components/shared/icons/ArrowBack";
import styles from "./PackageActions.module.scss";


// Picking works with batches, so there is no action on the package level.
// - a batch can be marked as picked;
// - a job can be removed from a batch and thrown back to the first lane.
const PickingActions = (props) => {
  const { jobId, batchId } = props;
  
  if (jobId) {
    return <ActionsForSingleJob {...props} />;
  } else  if (batchId) {
    return <ActionsForBatch {...props} />;
  } else {
    return null;
  }
}

// User can mark a whole batch as picked
function ActionsForBatch(props) {
  const { warehouseId, batchId, allPackages } = props;

  const dispatch = useDispatch();

  const handleBatchPicked = () => {
    // Update packages in the reducer
    dispatch(updatePackages(warehouseId, allPackages.map((p) => getPackageUID(p)), (p) => p.set("state", PACKAGE_STATES.PACK )));
    // Send mutation to server
    props.markBatchPicked(warehouseId, Set(allPackages.map((p) => p.get("jobId"))), batchId);
  }

  const handleBatchRevert = () => {
    // Update packages in the reducer
    dispatch(updatePackages(warehouseId, allPackages.map((p) => getPackageUID(p)), (p) => p.set("state", PACKAGE_STATES.DUE_TO_PROCESS )));
    // Send mutation to server
    return props.cancelBatchPicked(warehouseId, Set(allPackages.map((p) => p.get("jobId"))), batchId);
  }

  const onContextClick = (x, y) => {
    let items = [
      {label: "Mark as Picked", lambda: handleBatchPicked },
      {label: "Cancel Batch Picking", lambda: handleBatchRevert },
    ];

    props.showContextualMenu(items, x, y);
  }

  return (
    <div className={styles.headerActions}>
      <Button
        active={props.active}
        onClick={handleBatchPicked} label="Mark as Picked"
      />
      <ContextMenuTrigger active={props.active} onClick={onContextClick}/>
    </div>
  );
}

// User can Move one job from batch back to idle
function ActionsForSingleJob(props) {
  const { warehouseId, jobId, batchId, packages } = props;

  const dispatch = useDispatch();

  const handleJobRevert = () => {
    // Update packages in the reducer
    dispatch(updatePackages(warehouseId, packages.map((p) => getPackageUID(p)), (p) => p.set("state", PACKAGE_STATES.DUE_TO_PROCESS )));
    // Send mutation to server
    return props.cancelBatchPicked(warehouseId, [jobId], batchId);
  }

  return (
    <ArrowBack
      onClick={props.active ? handleJobRevert : undefined}
      color="var(--grey-900)"
    />
  );
}

const withQuery = compose(
  graphql(MARK_BATCH_PICKED, {
    props: ({ mutate }) => ({
      markBatchPicked: (warehouseId, jobIds, batchId) => mutate({
        variables: { data: { warehouseId, jobIds, batchId } }
      })
    })
  }),
  graphql(CANCEL_BATCH_PICKING, {
    props: ({ mutate }) => ({
      cancelBatchPicked: (warehouseId, jobIds, batchId) => mutate({
        variables: { data: { warehouseId, jobIds, batchId } }
      })
    })
  }),
);

export default connect(null, {showContextualMenu})(withQuery(PickingActions));